import React from 'react';
import { Breadcrumbs } from '../guide/Breadcrumbs';
type Crumb = {
  label: string;
  to?: string;
};

/** `media`: imagen opcional junto al título; los datos siguen debajo, sin desplazarse. */
export function WorldPageHeader({
  crumbs,
  eyebrow,
  title,
  media,
  children
}: {
  crumbs: Crumb[];
  eyebrow: string;
  title: string;
  media?: React.ReactNode;
  children?: React.ReactNode;
}) {
  return <header className="mb-4 md:mb-8" data-id="element-2100" data-mp="17zmn51fy9plt">
      <Breadcrumbs items={crumbs} data-id="element-2101" data-mp="17yl1y457zmqd" />
      <div className={media ? 'flex items-start gap-3 md:gap-5' : undefined} data-id="element-2102" data-mp="181qpvg244iki">
        {media}
        <div className="min-w-0 flex-1" data-id="element-2103" data-mp="1d0k45ap84dlq">
          <p className="text-xs md:text-sm font-semibold text-[#D4AF37]" data-id="element-2104" data-mp="1hxak7y113975">{eyebrow}</p>
          <h1 className="mt-1 md:mt-1.5 font-cinzel text-2xl md:text-5xl font-black leading-[1.1] text-white break-words" data-id="element-2105" data-mp="1lyvs14ypgxah">{title}</h1>
        </div>
      </div>
      {children}
    </header>;
}
export function WorldSection({
  id,
  title,
  count,
  children
}: {
  id: string;
  title: string;
  count?: number;
  children: React.ReactNode;
}) {
  return <section id={id} aria-labelledby={`${id}-t`} className="scroll-mt-20 md:scroll-mt-32 rounded-3xl py-1 md:py-2" data-id="element-2106" data-mp="yml5fad6efwf">
      <h2 id={`${id}-t`} className="mb-2.5 md:mb-4 flex items-baseline gap-2 font-cinzel text-lg md:text-2xl font-bold text-white" data-id="element-2107" data-mp="tt0d9yy9kg55">
        {title}
        {count !== undefined && <span className="font-sans text-sm font-normal text-gray-500" data-id="element-2108" data-mp="jxglnoqqg3m7">{count}</span>}
      </h2>
      {children}
    </section>;
}